import React from "react";
import { Image } from "react-bootstrap";

const InputField = ({ inputValue, inputType, triggerIndex, updateValue }) => {
    return <div className="position-relative w-100" style={{ zIndex: 0 }} >
        <span className="position-absolute top-0 start-0 w-30px f-center h-100" style={{ zIndex: 9 }}>
            <Image src={inputType} height={'16'} width={'16'} />
        </span>
        <input type='text' className="form-control" style={{paddingLeft:'30px'}} value={inputValue} onChange={e => updateValue(triggerIndex, e.target.value)} />
    </div>
}

export default InputField;